var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountryDoctorNb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1694502754383,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 13510,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M709.7 375.6c-4.4 0-9-0.9-13.6-2.7-118.7-46.8-249.5-46.8-368.2 0-10.8 4.3-21.9 3.4-30.4-2.3-7.6-5.2-12.1-13.7-12.1-22.9V133.4c0-15.5 12.1-27.3 24.1-32C374.3 75.8 442.4 62.9 512 62.9s137.7 12.9 202.4 38.5c12 4.7 24.1 16.5 24.1 32v214.3c0 9.2-4.5 17.8-12.1 22.9-4.8 3.3-10.6 5-16.7 5zM512 287.9c60.4 0 119.7 9.7 176.6 29V145c-114.2-43-239-43-353.1 0v171.9c56.8-19.2 116.1-29 176.5-29zM851.7 957H173.2c-11.7 0-22.8-4.7-31.2-13.4-8.8-9-13.8-21.5-13.8-34.4-9.6-104.8 14.4-189.6 71.2-251.9 35.8-39.3 84.2-68.9 143.9-88 51.8-16.6 111.2-25 176.4-25 124 0 229.5 40 297.1 112.7 29 31.2 50.6 67.9 64.1 109.2 14.1 43 19.4 91.1 15.8 142.8 0 13.1-5 25.7-13.9 34.8-8.4 8.5-19.4 13.2-31.1 13.2z m-673.5-50h668.5v-0.8c6.3-88.5-16.1-160.9-66.6-215.2-58.1-62.4-150.6-96.8-260.6-96.8-89.1 0-210.5 16.8-283.3 96.7-47.1 51.8-66.7 124-58.2 214.7 0.2 0.5 0.2 1 0.2 1.4z",
    "p-id": 13511,
    fill: "#2c2c2c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M511 588.3c-30.8 0-60.9-7.7-89.6-23-26.2-13.9-50-33.4-70.8-57.9-19.6-23.1-35.8-50.3-46.9-78.6-11.3-29-17.3-59.4-17.3-87.8h50c0 45.3 19.6 95.4 52.3 134.1 34.5 40.7 78 63.2 122.3 63.2 97.8 0 176.6-107.5 176.6-196.5h50c0 28.5-6.1 58.9-17.7 87.9-11.2 28.2-27.7 55.3-47.6 78.3-21 24.3-45 43.7-71.4 57.5-28.9 15.1-59.2 22.8-89.9 22.8zM591 915h-62L285 734.9 397 609z",
    "p-id": 13512,
    fill: "#2c2c2c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M511.3 845l64.8 54L739 731.3 651 609zM576.4 175H537v-39.4h-50V175h-39.4v50H487v39.4h50V225h39.4z",
    "p-id": 13513,
    fill: "#2c2c2c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryDoctorNb);
export default __webpack_public_path__ + "static/media/countryDoctorNb.7d571e5d.svg";
export { ForwardRef as ReactComponent };